import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {PaginationComponent} from "./pagination.component";
import {ButtonModule} from "../button/button.module";
import {MatPaginatorModule} from "@angular/material/paginator";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ButtonModule,
        MatPaginatorModule,
    ],
    declarations: [
        PaginationComponent,
    ],
    exports: [
        PaginationComponent
    ]
})
export class PaginationModule {}
